<p-dialog modal="true" styleClass="atlas-dialog-s" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>
      {{ 'revenue.pledge-campaigns.pledge-campaign.add-header' | translate | titlecase }}
    </h4>
  </ng-template>
  <form #crudForm="ngForm" class="atlas-form">
    <div class="mct-flex mct-col mct-gap-27">
      <div>
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.campaign-name' | translate | titlecase }}</label>
        <input [(ngModel)]="pledgeCampaign.CampaignName" name="campaignName" required />
      </div>
      <div>
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.campaign-type' | translate | titlecase }}</label>
        <p-select
          required
          appendTo="body"
          name="campaignTypeId"
          [(ngModel)]="pledgeCampaign.PledgeCampaignTypeId"
          [options]="pledgeCampaignTypes"
          showClear
          [placeholder]="'revenue.pledge-campaigns.pledge-campaign.campaign-type-placeholder' | translate | titlecase"
          [style]="{ width: '100%' }"
        ></p-select>
      </div>
      <div>
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.start-date' | translate | titlecase }}</label
        ><br />
        <wl-date-selector
          ngDefaultControl
          appendTo="body"
          [required]="true"
          name="startDate"
          [(ngModel)]="pledgeCampaign.StartDate"
          [style]="{ width: '100%' }"
        ></wl-date-selector>
      </div>
      <div>
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.end-date' | translate | titlecase }}</label
        ><br />
        <wl-date-selector
          ngDefaultControl
          appendTo="body"
          [required]="true"
          name="endDate"
          [(ngModel)]="pledgeCampaign.EndDate"
          [style]="{ width: '100%' }"
        ></wl-date-selector>
      </div>
      <div class="w-100 mct-flex mct-col">
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.goal' | translate | titlecase }}</label>
        <div class="p-inputgroup">
          <span class="atlas-input-addon">$</span>
          <p-inputNumber
            name="goal"
            [(ngModel)]="pledgeCampaign.Goal"
            showClear="true"
            mode="decimal"
            [style]="{ width: '100%' }"
            [min]="0"
          ></p-inputNumber>
        </div>
      </div>
      <div>
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.campaign-year' | translate | titlecase }}</label>
        <p-datepicker
          appendTo="body"
          name="campaignYear"
          showClear="true"
          [(ngModel)]="pledgeCampaignYear"
          view="year"
          dateFormat="yy"
          [style]="{ width: '100%' }"
          showIcon="true"
        ></p-datepicker>
      </div>
      <div>
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.campaign-descr' | translate | titlecase }}</label>
        <textarea pInputTextarea [(ngModel)]="pledgeCampaign.Descr" name="campaignDescr" class="w-100"></textarea>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!crudForm.valid" (click)="save()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
